var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyPageIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21884",
    "data-name": "\\uADF8\\uB8F9 21884",
    transform: "translate(0 -0.362)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_27583",
    "data-name": "\\uC0AC\\uAC01\\uD615 27583",
    width: 32,
    height: 32,
    transform: "translate(0 0.362)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21390",
    "data-name": "\\uADF8\\uB8F9 21390",
    transform: "translate(2.96 3.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10113",
    "data-name": "\\uD328\\uC2A4 10113",
    d: "M25.706,29.642a2.4,2.4,0,0,0-1.882.049,2.957,2.957,0,0,0-1.554,1.071,9.408,9.408,0,0,0-.72,1.823.818.818,0,0,1-1.412.255,7.191,7.191,0,0,1-.535-1.445,3.059,3.059,0,0,0-2.632-1.921,4.362,4.362,0,0,0-2.232.7,1.631,1.631,0,0,1-.636.239.951.951,0,0,1-.839-.839,1.621,1.621,0,0,1,.24-.636c.138-.29.281-.577.415-.869a3.123,3.123,0,0,0-.537-3.3,4.4,4.4,0,0,0-1.952-.994c-.558-.2-1.172-.511-.825-1.268.208-.454,1.027-.568,1.443-.717a4.6,4.6,0,0,0,.8-.334,2.909,2.909,0,0,0,1.135-1.6,2.985,2.985,0,0,0-.3-2.63c-.3-.632-.748-1.188.007-1.71a.66.66,0,0,1,.73-.061c.327.144.646.308.968.462a3.411,3.411,0,0,0,1.226.394,3.68,3.68,0,0,0,1.991-.6,3.912,3.912,0,0,0,1.33-2.276,1.2,1.2,0,0,1,.375-.68.883.883,0,0,1,1.125.179A7.152,7.152,0,0,1,22,14.452c.376,1.053,2.068.6,1.689-.466-.173-.485-.335-.975-.52-1.456a2.559,2.559,0,0,0-3.089-1.557,2.712,2.712,0,0,0-1.828,1.995c-.286.8-.368,1.384-1.341,1.575-.488.1-1.16-.4-1.678-.64a2.533,2.533,0,0,0-3.165.776,2.582,2.582,0,0,0-.119,2.951c.148.31.32.619.448.938a.6.6,0,0,1,.068.324,2.159,2.159,0,0,1-.365.931,1.287,1.287,0,0,1-.6.3c-.33.118-.663.229-.989.354a2.552,2.552,0,0,0,.085,4.844c.478.176,1.316.281,1.587.76.5.888.127,1.311-.27,2.143a2.581,2.581,0,0,0,3.4,3.607c.3-.137.589-.282.884-.422a1.011,1.011,0,0,1,1.078-.04,1,1,0,0,1,.714.68c.126.355.249.711.38,1.064a2.555,2.555,0,0,0,2.987,1.71c1.16-.2,1.651-1.113,2.009-2.116a6.838,6.838,0,0,1,.327-.915,1.345,1.345,0,0,1,1.554-.465.881.881,0,0,0,1.077-.612.9.9,0,0,0-.611-1.077",
    transform: "translate(-8.802 -10.884)",
    fill: "#343a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10114",
    "data-name": "\\uD328\\uC2A4 10114",
    d: "M25.316,27.415a4.986,4.986,0,0,1-7.051-7.051,4.892,4.892,0,0,1,3.909-1.412",
    transform: "translate(-9.803 -11.887)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10115",
    "data-name": "\\uD328\\uC2A4 10115",
    d: "M34.22,15.5V11.992a.384.384,0,0,1,.65-.278c1.356,1.331,4,4.789-.5,8.349a.38.38,0,0,0-.149.3V31.844A1.252,1.252,0,0,1,32.966,33.1H31.6a1.255,1.255,0,0,1-1.255-1.254V20.363a.389.389,0,0,0-.148-.3c-4.5-3.56-1.858-7.019-.5-8.349a.384.384,0,0,1,.65.278V15.5a.386.386,0,0,0,.233.354l1.553.666a.389.389,0,0,0,.3,0l1.553-.666A.386.386,0,0,0,34.22,15.5Z",
    transform: "translate(-11.155 -10.974)",
    fill: "none",
    stroke: "#343a40",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPageIcon2);
export default __webpack_public_path__ + "static/media/myPageIcon2.12f29e5df0ebc559984724ce63f36b84.svg";
export { ForwardRef as ReactComponent };